import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { X } from "lucide-react";
import type { FC } from "react";
import { InspirationCheckRow } from "web_myplann/Inspiration/Components/InspirationCheckRow";
import { useRetirementDropRow } from "web_myplann/Inspiration/Retirement/Hooks/useRetirementDropRow";
import type { RetirementDrop } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

type Props = {
	drop: RetirementDrop;
	onToggle: () => void;
	onRemove: () => void;
};

export const RetirementDropRow: FC<Props> = ({ drop, onToggle, onRemove }) => {
	const theme = useTheme();
	const { label, note, amount, removeLabel, isManual, textColor, amountColor } =
		useRetirementDropRow(drop);

	return (
		<InspirationCheckRow
			checked={drop.checked}
			disabled={!drop.deductible}
			onToggle={onToggle}
			trailing={
				isManual && (
					<IconButton
						variant="ghost"
						aria-label={removeLabel}
						onClick={onRemove}
					>
						<X size={theme.iconSize.sm} />
					</IconButton>
				)
			}
		>
			<Stack flex={1} minWidth={0}>
				<Typography variant="bodyMedium" color={textColor} noWrap>
					{label}
				</Typography>
				<Typography variant="caption" color={theme.palette.grey[500]}>
					{note}
				</Typography>
			</Stack>
			<Typography variant="value" color={amountColor} flexShrink={0} tabular>
				{amount}
			</Typography>
		</InspirationCheckRow>
	);
};
